import { useTranslation } from 'react-i18next';

import { SelfMatchAction } from 'components/types';

import { SelfMatchAction as SelfMatchActionEnum } from 'components/enums';

import CellCheckAll from './CellCheckAll';

type Props = {
  checks: [boolean, boolean | null, boolean | null];
  onChecked: (action: SelfMatchAction) => void;
};

export default function CheckboxTable({ checks, onChecked }: Props) {
  const { t } = useTranslation('common');

  return (
    <table>
      <thead>
        <tr>
          <th>
            <div />
          </th>
          <CellCheckAll
            checked={checks[0]}
            onClick={() => {
              onChecked(SelfMatchActionEnum.NONE);
            }}
            label={t('none')}
          />
          {checks[1] !== null && (
            <CellCheckAll
              checked={checks[1]}
              onClick={() => {
                onChecked(SelfMatchActionEnum.SUBSCRIBE);
              }}
              label={t('subscribe')}
            />
          )}
          {checks[2] !== null && (
            <CellCheckAll
              checked={checks[2]}
              onClick={() => {
                onChecked(SelfMatchActionEnum.CONNECT);
              }}
              label={t('connect')}
            />
          )}
        </tr>
      </thead>
    </table>
  );
}
